export const PERMISSION_MODULES = [
  // Core
  { key: "dashboard", label: "Dashboard", category: "Core" },
  { key: "user", label: "User Management", category: "Core" },
  { key: "role", label: "Role Management", category: "Core" },

  // Trading
  { key: "coin", label: "Coin Management", category: "Trading" },
  { key: "trading-pair", label: "Trading Pairs", category: "Trading" },
  { key: "pair-category", label: "Pair Categories", category: "Trading" },
  { key: "order", label: "Orders", category: "Trading" },
  { key: "order-transaction", label: "Order Transactions", category: "Trading" },

  // Finance
  { key: "wallet", label: "Wallets", category: "Finance" },
  { key: "user-wallet", label: "User Wallets", category: "Finance" },
  { key: "coin-buy-sell", label: "Coin Buy/Sell", category: "Finance" },
  { key: "wallet-transfer", label: "Wallet Transfers", category: "Finance" },
  { key: "fund-transfer", label: "Fund Transfers", category: "Finance" },
  { key: "wallet-tx-review", label: "Wallet Tx Review", category: "Finance" },
  { key: "bulk-trade-request", label: "Bulk Trade Requests", category: "Finance" },
  { key: "compliance-config", label: "Compliance Config", category: "Finance" },
  { key: "kyc-config", label: "KYC Configuration", category: "Finance" },
  { key: "finance-overview", label: "Finance Overview (Fee & Revenue)", category: "Finance" },
  { key: "finance-withdrawal-fees", label: "Crypto Withdrawal Fees", category: "Finance" },
  { key: "finance-tds", label: "TDS Reports", category: "Finance" },
  { key: "finance-inr-deposit", label: "INR Deposits", category: "Finance" },
  { key: "finance-inr-withdraw", label: "INR Withdrawals", category: "Finance" },
  { key: "finance-funding-wallet-tx", label: "Funding Wallet Transactions", category: "Finance" },
  { key: "finance-fiu-reports", label: "FIU Reports", category: "Finance" },
  { key: "wallet-detail", label: "Wallet Detail (User Tx History)", category: "Finance" },
  { key: "otc-transactions", label: "OTC Transactions", category: "Finance" },
  { key: "otc-address-monitoring", label: "OTC Address Monitoring", category: "Finance" },

  // P2P
  { key: "p2p-support-coin", label: "P2P Support Coins", category: "P2P" },
  { key: "p2p-orders", label: "P2P Orders", category: "P2P" },
  { key: "p2p-ads", label: "P2P Ads", category: "P2P" },
  { key: "p2p-order-trx", label: "P2P Order Transactions", category: "P2P" },
  { key: "chat", label: "P2P Chat", category: "P2P" },
  { key: "p2p-order-rating", label: "P2P Ratings", category: "P2P" },

  // Content
  { key: "support", label: "Support", category: "Content" },
  { key: "home-faq", label: "FAQ", category: "Content" },
  { key: "policy-link", label: "Policy Links", category: "Content" },
  { key: "news-letter", label: "Newsletter", category: "Content" },
  { key: "contact-us", label: "Contact Us", category: "Content" },
  { key: "notification", label: "Notifications", category: "Content" },

  // Infrastructure
  { key: "currency", label: "Currencies", category: "Infrastructure" },
  { key: "payment-method", label: "Payment Methods", category: "Infrastructure" },
  { key: "coin-network", label: "Coin Networks", category: "Infrastructure" },
  { key: "fireblocks-config", label: "Fireblocks Configuration", category: "Infrastructure" },

  // Affiliates
  { key: "affiliate", label: "Affiliate Codes", category: "Affiliates" },

  // Activity
  { key: "logs", label: "Logs", category: "Activity" },

  // System
  { key: "maintenance", label: "Maintenance Mode", category: "System" },
  { key: "feature-toggle", label: "Deposit / Withdrawal Controls", category: "System" },
];

export const PERMISSION_ACTIONS = ["view", "create", "update", "delete"];

export const PERMISSION_CATEGORIES = [
  "Core",
  "Trading",
  "Finance",
  "P2P",
  "Content",
  "Infrastructure",
  "Affiliates",
  "Activity",
  "System",
];

export const ROUTE_TO_MODULE = {
  "/admin": "dashboard",
  "/admin/user": "user",
  "/admin/roles": "role",
  "/admin/admin-users": "role",
  "/admin/coin": "coin",
  "/admin/tradingPair": "trading-pair",
  "/admin/wallet": "wallet",
  "/admin/order": "order",
  "/admin/withdrawal": "coin-buy-sell",
  "/admin/deposit": "coin-buy-sell",
  "/admin/faq": "home-faq",
  "/admin/policy-link": "policy-link",
  "/admin/newsletter": "news-letter",
  "/admin/contact-us": "contact-us",
  "/admin/edd": "user",
  "/admin/alert": "user",
  "/admin/third-party-stats": "dashboard",
  "/admin/balance-comparison": "dashboard",
  "/admin/coindcx-orders": "order",
  "/admin/network": "coin-network",
  "/admin/support": "support",
  "/admin/currency": "currency",
  "/admin/payment": "payment-method",
  "/admin/p2p": "p2p-support-coin",
  "/admin/gullak-plans": "dashboard",
  "/admin/user-profile": "dashboard",
  "/admin/fireblocks-sync": "fireblocks-config",
  "/admin/compliance": "compliance-config",
  "/admin/wallet-review": "wallet-tx-review",
  "/admin/finance/overview": "finance-overview",
  "/admin/finance/withdrawal-fees": "finance-withdrawal-fees",
  "/admin/finance/tds": "finance-tds",
  "/admin/finance/funding-wallet-transactions": "finance-funding-wallet-tx",
  "/admin/wallet/transactions": "wallet-detail",
  "/admin/otc/transactions": "otc-transactions",
  "/admin/otc/address-monitoring": "otc-address-monitoring",
  "/admin/bulk-trade-request": "bulk-trade-request",
  "/admin/finance/inr-deposits": "finance-inr-deposit",
  "/admin/finance/inr-withdrawals": "finance-inr-withdraw",
  "/admin/finance/fiu-reports": "finance-fiu-reports",
  "/admin/affiliate": "affiliate",
  "/admin/kyc-config": "kyc-config",
  "/admin/logs": "logs",
  "/admin/maintenance": "maintenance",
  "/admin/feature-toggle": "feature-toggle",
};

export const hasPermission = (permissions, module, action = "view") => {
  if (!permissions || !Array.isArray(permissions)) return false;
  const modulePerm = permissions.find((p) => p.module === module);
  return modulePerm ? modulePerm[action] === true : false;
};

export const isSuperAdmin = (role) => {
  return role?.roleType === 1;
};
